<ion-header class="remove-margin-from-safe-area ion-no-border" *ngIf="loaded">
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-toolbar>
                        <ion-buttons slot="end">
                            <ion-button (click)="closeModal()"
                            >
                                <ion-icon color="dark" name="close"></ion-icon
                                >
                            </ion-button>
                        </ion-buttons>
                    </ion-toolbar>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col style="text-align: center;">
                    <h2 class="subheader-regular"> {{ permitsSRV.permit.value['permit'].Lot.LotName }}</h2>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col class="ion-no-padding" style="text-align: center">
                    <h5 class="ion-text-wrap" style="font-weight: bold;">{{('keys.data.permits.waiting_list'|translate : {Default: 'Waiting List'}) || "Waiting List"}}</h5>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="permitsSRV.permit.value['permit'].Lot.Location">
                <ion-col style="text-align: center">
                    <ion-label class="ion-text-wrap">
                        {{ permitsSRV.permit.value['permit'].Lot.Location }}
                    </ion-label>
                </ion-col>
            </ion-row>

        </ion-grid>

    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-card *ngIf="!loaded">
        <ion-grid>
            <ion-row>
                <ion-col size="12">
                    <h1 style="text-align: center; font-weight: bold; color: black">
                        <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                    </h1>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <h2 style="text-align: center">
                        <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                    </h2>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col class="single-col-wider">
                    <ion-card-content>
                        <ion-card>
                            <ion-grid>
                                <ion-row>
                                    <ion-col style="text-align: center">
                                        <ion-chip>
                                            <ion-label>
                                                <ion-skeleton-text
                                                        animated
                                                        style="width: 40%"
                                                ></ion-skeleton-text
                                                >
                                            </ion-label>
                                        </ion-chip>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <ion-card>
                                            <ion-item lines="none">
                                                <ion-label>
                                                    <ion-skeleton-text
                                                            animated
                                                            style="width: 20%"
                                                    ></ion-skeleton-text
                                                    >
                                                </ion-label>
                                                <ion-label style="text-align: right">
                                                    <ion-skeleton-text
                                                            animated
                                                            style="width: 60%"
                                                    ></ion-skeleton-text>
                                                </ion-label>
                                            </ion-item>
                                        </ion-card>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <ion-item>
                                            <ion-label>
                                                <ion-skeleton-text
                                                        animated
                                                        style="width: 60%"
                                                ></ion-skeleton-text>
                                            </ion-label>
                                            <ion-label style="text-align: right">
                                                <ion-skeleton-text
                                                        animated
                                                        style="width: 60%"
                                                ></ion-skeleton-text>
                                            </ion-label>
                                        </ion-item>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <ion-item>
                                            <ion-label>
                                                <ion-skeleton-text
                                                        animated
                                                        style="width: 60%"
                                                ></ion-skeleton-text>
                                            </ion-label>
                                            <ion-label style="text-align: right">
                                                <ion-skeleton-text
                                                        animated
                                                        style="width: 60%"
                                                ></ion-skeleton-text>
                                            </ion-label>
                                        </ion-item>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <ion-item lines="none" style="font-weight: bold">
                                            <ion-label>
                                                <ion-skeleton-text
                                                        animated
                                                        style="width: 60%"
                                                ></ion-skeleton-text>
                                            </ion-label>
                                            <ion-label style="text-align: right">
                                                <ion-skeleton-text
                                                        animated
                                                        style="width: 60%"
                                                ></ion-skeleton-text>
                                            </ion-label>
                                        </ion-item>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>

                                        <ion-skeleton-text
                                                animated
                                                style="width: 60%"
                                        ></ion-skeleton-text>

                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-card>
                    </ion-card-content>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card>
    <div
            *ngIf="loaded"

    >
        <ion-grid
                class="ion-no-padding"
                *ngIf="
        permitsSRV.permit.value['status'] == 'success' ||
        (permitsSRV.permit.value['status'] == 'error' &&
          permitsSRV.permit.value['message'] == errors.SOLD_OUT) ||
        (permitsSRV.permit.value['status'] == 'error' &&
          permitsSRV.permit.value['message'] ==
            errors.ALREADY_HAS_PERMIT) ||
        (permitsSRV.permit.value['status'] == 'error' &&
          permitsSRV.permit.value['message'] == errors.ALREADY_ON_WAITING_LIST)
      "
        >

            <ion-row>
                <ion-col style="text-align: center">
                    <ion-chip style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;">
                        {{ ('keys.data.permits.sale_window' | translate : {Default: 'Sale Window'}) || 'Sale Window' }} {{ permitsSRV.permit.value['permitWindowTypes'][permitsSRV.permit.value['permit'].Lot.LotType] }}
                    </ion-chip>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col class="single-col-wider">
                    <ion-card class="card-shadow-7">
                        <ion-grid class="ion-no-padding">

                            <ion-row>
                                <ion-col class="ion-no-padding">

                                    <ion-row *ngIf="permitsSRV.permit.value['permit']['prorated']">
                                        <ion-col>
                                            <div style="text-align: center">
                                                <ion-chip color="success"> {{ ('keys.data.common.prorated' | translate : {Default: 'Prorated'}) || 'Prorated' }}</ion-chip>
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <ion-item class="paragraph-bold"
                                                      *ngFor="let item of permitsSRV.permit.value['items']"
                                                      lines="none"
                                            >

                                                <ion-label> {{ item.label }}  </ion-label>
                                                <ion-label style="text-align: right">
                                                    {{ item.price | currency }}
                                                </ion-label>
                                            </ion-item>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <ion-item lines="none" class="paragraph-input-fields-regular">
                                                <ion-label>
                                                    {{ ('keys.data.common.subtotal' | translate : {Default: 'Subtotal'}) || 'Subtotal' }}
                                                </ion-label>
                                                <ion-label style="text-align: right">
                                                    {{ permitsSRV.permit.value['dollarvalues'].subtotal | currency }}
                                                </ion-label>
                                            </ion-item>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <ion-item lines="none" class="paragraph-input-fields-regular">
                                                <ion-label>
                                                    {{ ('keys.data.common.taxes' | translate : {Default: 'Taxes'}) || 'Taxes' }}
                                                </ion-label>
                                                <ion-label style="text-align: right">
                                                    {{ permitsSRV.permit.value['dollarvalues'].taxes | currency }}
                                                </ion-label>
                                            </ion-item>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <ion-item lines="none" class="paragraph-input-fields-bold">
                                                <ion-label>
                                                    {{ ('keys.data.common.total_owing' | translate : {Default: 'Total Owing'}) || 'Total Owing' }}
                                                </ion-label>
                                                <ion-label style="text-align: right">
                                                    {{ permitsSRV.permit.value['dollarvalues'].total | currency }}
                                                </ion-label>
                                            </ion-item>
                                        </ion-col>
                                    </ion-row>

                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>

        <ng-container *ngFor="let waitlist of permitsSRV.permit.value['waitlist_current'] | keyvalue; first as isFirst">
            <div *ngIf="permitsSRV.permit.value['status'] == 'success' && waitlist.value.rank > 0 && isFirst && dataService.settings['permits']?.['enable_multiple_permit_waiting_lists'] == false" class="alert alert-warning">
                <ion-row>
                    <ion-col class="ion-text-center">
                        {{ ('keys.data.permits.by_joining_this_list' | translate : {Default: 'By moving to this list, you will be removed from the waiting list you are currently on.'}) || 'By moving to this list, you will be removed from the waiting list you are currently on.' }}
                    </ion-col>
                </ion-row>

                <ion-row *ngFor="let wait_item of permitsSRV.permit.value['waitlist_current'] | keyvalue;">
                    <ion-col class="ion-text-center">
                        <h5 style="font-weight: bold; color: red;">
                            {{ wait_item.value.lot }} <span *ngIf="dataService.settings['permits']?.['show_waitlist_rank'] == true">| {{ ('keys.data.permits.rank' | translate : {Default: 'Rank'}) || 'Rank' }}: #{{ wait_item.value.rank }}</span>
                        </h5>
                    </ion-col>
                </ion-row>
            </div>
        </ng-container>

        <ion-grid>
            <ion-row *ngIf="permitsSRV.permit.value['status'] == 'success' && permitsSRV.permit.value['permit']['Stats']['OnLotList'] == '0'">
                <ion-col class="ion-text-center">
                    <ion-button (click)="joinWaitingList()" color="primary">
                        {{ ('keys.data.permits.join_waiting_list' | translate : {Default: 'Join Waiting List'}) || 'Join Waiting List' }}
                    </ion-button>
                </ion-col>
            </ion-row>

            <ion-row *ngIf="permitsSRV.permit.value['status'] == 'success' && permitsSRV.permit.value['message'] == errors.ALREADY_ON_WAITING_LIST;">
                <ion-col class="ion-text-center">
                    <ion-button disabled color="primary">
                        {{ ('keys.data.permits.join_waiting_list' | translate : {Default: 'Join Waiting List'}) || 'Join Waiting List' }}
                    </ion-button>
                </ion-col>
            </ion-row>

            <ion-row *ngIf="permitsSRV.permit.value['status'] == 'success' && permitsSRV.permit.value['permit']?.Lot?.AllowOnWaitList">
                <ion-col style="text-align: center">
                    <ion-item lines="none" class="paragraph-regular">
                        <ion-icon color="secondary" name="information-circle"></ion-icon>
                        <ion-label *ngIf="dataService.settings['permits']?.['show_waitlist_rank'] == true">
                            You will be ranked {{ permitsSRV.permit.value['rank'] }} on this Waiting List.
                        </ion-label>

                        <ion-label *ngIf="dataService.settings['permits']?.['show_waitlist_rank'] == false">
                            {{ ('keys.data.permits.waitlist_not_on_no_rank' | translate : {Default: 'You are not on this waitlist.'}) || 'You are not on this waitlist.' }}
                        </ion-label>
                    </ion-item>
                </ion-col>
            </ion-row>

            <ion-row *ngIf="permitsSRV.permit.value['status'] == 'error'">
                <ion-col style="text-align: center">
                    <ion-button disabled color="primary">
                        {{ ('keys.data.permits.join_waiting_list' | translate : {Default: 'Join Waiting List'}) || 'Join Waiting List' }}
                    </ion-button>
                </ion-col>
            </ion-row>

            <ion-row *ngIf=" permitsSRV.permit.value['status'] == 'error'">
                <ion-col size="12">
                    <ion-item lines="none" class="paragraph-regular">
                        <ion-icon color="danger" name="information-circle"></ion-icon>

                        <ion-label>
                            {{ permitsSRV.permit.value['message'] }}
                        </ion-label>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</ion-content>
